// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","wrapper":"styles_wrapper__0W3Gj","container":"styles_container__Vnq_5","subtitle":"styles_subtitle__v9nja"};